import HeaderBlock from 'modules/profile/user-plan/components/price-plan-columns/components/header-block'
import { BillingPeriodEnum } from 'modules/profile/user-plan/enums/billing-period-enum'
import {
  UserPlanInterface,
  UserResourcesInterface,
  tableFeatures,
} from 'modules/profile/user-plan/types/user-plan-interface'
import { getPricePlanFeatureTitle } from 'modules/profile/user-plan/utils/price-plan-utils'
import React from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { twMerge } from 'tailwind-merge'

export interface ActiveUserPlanColumnProps {
  pricePlan: UserPlanInterface
  billingPeriod: BillingPeriodEnum
  userRecourses: UserResourcesInterface
  showWithTax: boolean
}

const ActiveUserPlanColumn = ({
  pricePlan,
  billingPeriod,
  userRecourses,
  showWithTax,
}: ActiveUserPlanColumnProps) => {
  const { t } = useLocoTranslation()

  return (
    <div className="border-brand-primary bg-brand-primary/[0.06] slideScrollSnapAlignStart flex w-full min-w-full flex-col gap-2 rounded-sm border border-solid lg:grid">
      <HeaderBlock
        pricePlan={pricePlan}
        billingPeriod={billingPeriod}
        active
        showWithTax={showWithTax}
      />
      {tableFeatures.map((column, index) => (
        <React.Fragment key={`active-column-${column.key}`}>
          <div
            className={twMerge(
              'text-text-primary font-inter truncate text-center text-base',
              column.resourceKey &&
                userRecourses[column.resourceKey] > pricePlan[column.key] &&
                'text-danger',
            )}
          >
            {(column.resourceKey ? `${userRecourses[column.resourceKey]}/` : '').concat(
              getPricePlanFeatureTitle({
                pricePlan,
                key: column.key,
                t,
              }),
            )}
          </div>
          {tableFeatures[index + 1] ? (
            <hr className="border-fill-primary -mr-6 border-solid" />
          ) : (
            <div />
          )}
        </React.Fragment>
      ))}
    </div>
  )
}

export default ActiveUserPlanColumn
